export default function(_) {
  return typeof _ === 'number';
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/isNumber.js
// module id = 871
// module chunks = 0